import { defineMessages } from 'react-intl';

export const productEditorMessages = defineMessages({
  availableForAdminsOnly: {
    id: 'productEditor.editor.availableForAdminsOnly',
    defaultMessage: 'Available for admins only',
  },
});
